import {create} from "zustand";
import moment from 'moment/moment'
import {getShopClosure} from "../services/ShopClosureAPI.ts";

interface StoreShopClosureInterface {
    initialised: boolean;
    shopIsClosed: boolean,
    closeDateStart: null|string,
    closeDateEnd: null|string,
    initialiseShopIsClosed: () => void
}

export const useStoreShopClosure = create<StoreShopClosureInterface>((set) => ({
    initialised: false,
    shopIsClosed: false,
    closeDateStart: null,
    closeDateEnd: null,
    initialiseShopIsClosed: (): void => {
        getShopClosure()
            .then(({data}) => {
                set({
                    shopIsClosed: false,
                    closeDateStart: null,
                    closeDateEnd: null,
                });

                if (data.length > 0) {
                    const [dates] = data;

                    set({
                        shopIsClosed: true,
                        closeDateStart: moment(dates.dateStart).format('DD/MM/YY'),
                        closeDateEnd: moment(dates.dateEnd).format('DD/MM/YY'),
                    });
                }

                set({initialised: true});
            });
    }
}));